import {CommonMessages} from '../common.messages';

export const PanelCampaignManagementMessages = {
    GetCampaignsFailed: {
        key: 'GetCampaignsFailed',
        message: 'Error while communication with the server. Unable to get the campaign registry.'
    },
    CreateCampaignSuccess: {
        key: 'CreateCampaignSuccess',
        message: 'Campaign created successfully.'
    },
    CreateCampaignFailed: {
        key: 'CreateCampaignFailed',
        message: 'Error while communication with the server. Unable to create the campaign.'
    },
    /** The registry compares codes trimmed and case-insensitively, so the server answers 409 Conflict. */
    DuplicateCampaignCode: {
        key: 'DuplicateCampaignCode',
        message: 'Campaign code already exists'
    },
    DeactivateCampaignSuccess: {
        key: 'DeactivateCampaignSuccess',
        message: 'Campaign deactivated successfully.'
    },
    ReactivateCampaignSuccess: {
        key: 'ReactivateCampaignSuccess',
        message: 'Campaign reactivated successfully.'
    },
    UpdateCampaignFailed: {
        key: 'UpdateCampaignFailed',
        message: 'Error while communication with the server. Unable to update the campaign.'
    },
    ...CommonMessages
};
